var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.1875 7.125 0 16 0C24.8125 0 32 7.1875 32 16C32 24.875 24.8125 32 16 32C7.125 32 0 24.875 0 16ZM10.9375 13.0625L13.875 16L10.9375 18.9375C10.3125 19.5625 10.3125 20.5 10.9375 21.0625C11.5 21.6875 12.4375 21.6875 13 21.0625L15.9375 18.125L18.9375 21.0625C19.5 21.6875 20.4375 21.6875 21 21.0625C21.625 20.5 21.625 19.5625 21 18.9375L18.0625 16L21 13.0625C21.625 12.5 21.625 11.5625 21 10.9375C20.4375 10.375 19.5 10.375 18.9375 10.9375L15.9375 13.9375L13 10.9375C12.4375 10.375 11.5 10.375 10.9375 10.9375C10.3125 11.5625 10.3125 12.5 10.9375 13.0625Z",
    fill: "#CB1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.37d144d453d00fe38c101bb6d5cb0385.svg";
export { ForwardRef as ReactComponent };